import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { getInitialFilter } from "./PaymentReceivedReportUIHelpers";

const PaymentReceivedReportUIContext = createContext();

export function usePaymentReceivedReportUIContext() {
  return useContext(PaymentReceivedReportUIContext);
}

export const PaymentReceivedReportUIConsumer = PaymentReceivedReportUIContext.Consumer;

export function PaymentReceivedReportUIProvider({ brandPriceUIEvents, children }) {
  const [ids, setIds] = useState([]);
  const [PaymentReceivedReportEntities, setPaymentReceivedReportEntities] = useState([]);
  const [queryParams, setQueryParamsBase] = useState(getInitialFilter);
  const [requiredLength, setRequiredLength] = useState(17);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setIds,
    ids,
    PaymentReceivedReportEntities,
    setPaymentReceivedReportEntities,
    setQueryParamsBase,
    setQueryParams,
    requiredLength: requiredLength,
    setRequiredLength: setRequiredLength,
  };

  return <PaymentReceivedReportUIContext.Provider value={value}>{children}</PaymentReceivedReportUIContext.Provider>;
}
